import { TrialIds } from '../constants/trial';
import { createExternalUrl } from './urls';
export const generateTrialSignupUrl = ({
  trialId,
  dttSource,
  hubsSignupUrl,
  hubsSignupCta,
  uuid,
  experimentParams,
  location = 'pricing-page'
}) => {
  if (trialId === TrialIds.AEO_STANDALONE) {
    return createExternalUrl('/signup-hubspot/aeo');
  }
  const baseUrl = '/signup/trial-signup';
  const queryParams = {
    intent: 'trial',
    trialId,
    dtt_source: `${dttSource}-${location}`,
    'hubs_signup-url': hubsSignupUrl,
    'hubs_signup-cta': hubsSignupCta,
    uuid: uuid || null,
    experimentParams: experimentParams || null
  };
  return createExternalUrl(baseUrl, queryParams);
};